import React from "react";
import { useMap } from "react-leaflet";

import { useAppSelector } from "../redux/hooks";

const MapHooks: React.FC = () => {
  const [mapView, deviationReportMapData, routeMapRangeFromRedux]: [
    { lat: number; lon: number; zoom: number },
    DeviationReport,
    (
      | {
          lat: number;
          lng: number;
        }[]
      | L.LatLngBounds
    )
  ] = useAppSelector((state: RootState) => [
    state?.mapView?.mapView,
    state?.deviationReportData?.deviationMapData,
    state?.routeMapRange?.rangeMapArray,
  ]);
  // console.log("routeMapRangeFromRedux:", routeMapRangeFromRedux);

  const leafletMap = useMap();
  // console.log("leafletMap:", leafletMap);

  React.useEffect(() => {
    if (mapView && mapView.lat && mapView.lon && mapView.zoom) {
      const mapFlyTo = (lat: number, lon: number, zoom: number) => {
        setTimeout(() => {
          leafletMap.flyTo([lat, lon], zoom, { animate: true, duration: 1.2 });
        }, 500);
      };
      mapFlyTo(mapView.lat, mapView.lon, mapView.zoom);
    }
  }, [leafletMap, mapView]);

  React.useEffect(() => {
    if (deviationReportMapData) {
      const lat = deviationReportMapData?.loc?.lat!;
      const lon = deviationReportMapData?.loc?.lon!;
      const zoom = deviationReportMapData?.zoom!;

      const mapFlyTo = (lat: number, lon: number, zoom: number) => {
        setTimeout(() => {
          leafletMap.flyTo([lat, lon], zoom, { animate: true, duration: 1.2 });
        }, 500);
      };
      mapFlyTo(lat, lon, zoom);
    }
  }, [deviationReportMapData, leafletMap]);

  React.useEffect(() => {
    if (routeMapRangeFromRedux) {
      // console.log("routeMapRangeFromRedux:", routeMapRangeFromRedux);
      const range1 = (routeMapRangeFromRedux?.[0 as keyof typeof routeMapRangeFromRedux] ||
        (routeMapRangeFromRedux as L.LatLngBounds)?.getNorthEast()) as { lat: number; lng: number };
      const range2 = (routeMapRangeFromRedux?.[1 as keyof typeof routeMapRangeFromRedux] ||
        (routeMapRangeFromRedux as L.LatLngBounds)?.getSouthWest()) as { lat: number; lng: number };

      const flyToBounds = (range1: { lat: number; lng: number }, range2: { lat: number; lng: number }) => {
        setTimeout(() => {
          leafletMap.flyToBounds(
            [
              [range1.lat, range1.lng],
              [range2.lat, range2.lng],
            ],
            { animate: true, duration: 1.2 }
          );
        }, 500);
      };
      flyToBounds(range1, range2);
    }
  }, [leafletMap, routeMapRangeFromRedux]);

  return null;
};

export default MapHooks;
